<template>
  <el-dialog :visible.sync="visible" title="记录详情" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
  <!--<el-card shadow="never" class="aui-card&#45;&#45;fill">-->
   <!-- <div class="mod-club__courseprocess">-->
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
       <!-- <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
          <el-form-item>
              <el-button v-if="$hasPermission('club:courseprocess:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
          </el-form-item>-->
        <el-form-item>
          <el-button v-show="isAdd === '1'"  type="primary" @click="classHourAdd()">{{ $t('add') }}</el-button>
        </el-form-item>

      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="imgUrl" label="图片" header-align="center" align="center">
            <template slot-scope="scope">
            <el-image
                    style="width: 100px; height: 100px"
                    :src="scope.row.imgUrl"
                    ></el-image>
            </template>
        </el-table-column>

        <el-table-column prop="context" label="课程内容" header-align="center" align="center"></el-table-column>
        <el-table-column prop="classHourName" label="课时名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="createDate" label="上传时间" header-align="center" align="center"></el-table-column>

        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">

            <el-button v-show="isAdd === '1'" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <courseprocess-add-or-update v-if="courseProcessVisible" ref="courseprocessAddOrUpdate" @refreshDataList="getDataList"></courseprocess-add-or-update>
  <!--     弹窗, 新增 / 修改
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>-->
  </el-dialog>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import CourseprocessAddOrUpdate from './courseprocess-add-or-update'
import Template from '../devtools/template'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/club/courseProcess/page',
        getDataListIsPage: true,
        deleteIsBatch: true,
        deleteURL: '/club/courseProcess',
        createdIsNeed: false,
        activatedIsNeed: false
      },
      isAdd: '',
      visible: false,
      courseProcessVisible: false,
      dataForm: {
        classHourId: '',
        classHourName: ''
      }
    }
  },
  watch: {
  },
  components: {
    CourseprocessAddOrUpdate
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        console.log(this.dataForm)
        this.getDataList()
      //  this.query()
      })
    },
    // query () {
    //   const url = '/club/courseProcess/page'
    //   this.dataListLoading = true
    //   this.$http.get(
    //     url,
    //     {
    //       params: {
    //         order: this.order,
    //         orderField: this.orderField,
    //         page: this.mixinViewModuleOptions.getDataListIsPage ? this.page : null,
    //         limit: this.mixinViewModuleOptions.getDataListIsPage ? this.limit : null,
    //         classHourId: this.dataForm.classHourId
    //       }
    //     }
    //   ).then(({ data: res }) => {
    //     this.dataListLoading = false
    //     if (res.code !== 0) {
    //       this.dataList = []
    //       this.total = 0
    //       return this.$message.error(res.msg)
    //     }
    //     this.dataList = this.mixinViewModuleOptions.getDataListIsPage ? res.data.list : res.data
    //     this.total = this.mixinViewModuleOptions.getDataListIsPage ? res.data.total : 0
    //   }).catch(() => {
    //     this.dataListLoading = false
    //   })
    // },
    classHourAdd (id) {
      //  console.log(row)
      this.courseProcessVisible = true
      this.$nextTick(() => {
        this.$refs.courseprocessAddOrUpdate.dataForm.id = id
        this.$refs.courseprocessAddOrUpdate.dataForm.classHourId = this.dataForm.classHourId
        this.$refs.courseprocessAddOrUpdate.dataForm.classHourName = this.dataForm.classHourName
        this.$refs.courseprocessAddOrUpdate.init()
      })
    }
  }
}
</script>
